var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMixer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25.26 25.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#fff;stroke-linecap:round;stroke-miterlimit:10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sounds"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 0.5,
    y1: 24.76,
    x2: 0.5,
    y2: 5.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 6.57,
    y1: 24.76,
    x2: 6.57,
    y2: 11.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 12.63,
    y1: 24.76,
    x2: 12.63,
    y2: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 18.7,
    y1: 24.76,
    x2: 18.7,
    y2: 7.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 24.76,
    y1: 24.76,
    x2: 24.76,
    y2: 15.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMixer);
export default __webpack_public_path__ + "static/media/mixer.4be3afb9c5990d3fed01bfbd784e4b84.svg";
export { ForwardRef as ReactComponent };